export default __webpack_public_path__ + "static/media/Wooden.62b90dc4.mp3";